import { connect } from 'react-redux'
import { updateVisitor } from 'base/actions/synchronous'
import { getShippingCountry } from 'base/lib/localization'
import store from 'base/store'

const PDP_DUTY_AND_TAX_TEXT_AU = 'Price includes GST'
const PDP_DUTY_AND_TAX_TEXT_DEFAULT = 'Price includes duties and VAT'

export function getDutyAndTaxText(props, isCheckout) {
  const hasEmbeddedDuties = shouldShowEmbeddedDuties(props)
  const hasEmbeddedTax = shouldShowEmbeddedTax(props)

  if (hasEmbeddedDuties) {
    return hasEmbeddedTax
      ? `No additional duties or taxes${isCheckout ? '' : ' at checkout'}.`
      : `No additional duties${isCheckout ? '' : ' at checkout'}.`
  }

  if (hasEmbeddedTax) {
    return `No additional taxes${isCheckout ? '' : ' at checkout'}.`
  }

  return null
}

export function getPDPDutyAndTaxText(props) {
  const countryCode = determineCountryCode(props)
  const hasEmbeddedDuties = shouldShowEmbeddedDuties(props)
  const hasEmbeddedTax = shouldShowEmbeddedTax(props)

  if (hasEmbeddedDuties) {
    if (hasEmbeddedTax) {
      if (countryCode === 'AU') {
        return PDP_DUTY_AND_TAX_TEXT_AU
      }
      return PDP_DUTY_AND_TAX_TEXT_DEFAULT
    }
  }

  return null
}

export function isDutyFree(props) {
  const countryCode = determineCountryCode(props)
  return store.getState().appConfig.dutyFreeCountries?.indexOf(countryCode) >= 0
}

export function shouldShowEmbeddedDuties(props) {
  const countryCode = determineCountryCode(props)
  const countriesWithEmbeddedDuties = store.getState().shippingConstants.embedded_duty_countries
  const isEmbeddedDutyCountry = countriesWithEmbeddedDuties?.includes(countryCode)
  const embeddedFLCEnabled = props.embeddedFLCOverride !== 'none'
  return isEmbeddedDutyCountry && embeddedFLCEnabled
}

export function shouldShowEmbeddedTax(props) {
  const countryCode = determineCountryCode(props)
  const countriesWithEmbeddedTaxes = store.getState().shippingConstants.embedded_tax_countries
  return countriesWithEmbeddedTaxes?.includes(countryCode)
}

export function determineCountryCode(props) {
  return getShippingCountry([], props.cartAddress)
}

function mapStateToProps(state) {
  const { visitor } = state.session

  const dismissedLoginGate = !!visitor.lastDismissedLoginGate
  const dismissedDutiesModal = !!visitor.lastDismissedEmbeddedDutiesModal

  if (state.session && visitor) {
    return {
      localization: visitor.localization,
      dismissedLoginGate: dismissedLoginGate,
      dismissedDutiesModal: dismissedDutiesModal,
      cartAddress: state.cart?.shipping_address ?? {},
      embeddedFLCOverride: state.appConfig.embeddedFLCOverride,
      intlFirstOrderFreeShippingEnabled: state.appConfig.intl_first_order_free_shipping_enabled,
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dismissDutiesModal: () => {
      const currentTime = Date.now()
      dispatch(updateVisitor({ lastDismissedEmbeddedDutiesModal: currentTime }))
    },
  }
}

export function embeddedDutiesAware(component) {
  return connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
  })(component)
}
